var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sub-page',{attrs:{"title":_vm.title}},[_c('div',{staticClass:"result-page"},[_c('div',{staticClass:"empty-wrap"},[_c('img',{staticClass:"empty-icon",attrs:{"src":_vm.emptyIcon,"alt":"暂无数据"}}),_vm._v(" "),_c('div',{staticClass:"empty-text"},[_vm._v(_vm._s(_vm.emptyText))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a050076","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/RightsRecordResult.vue
// module id = null
// module chunks = 